import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../../layout/Layout";

const TermsOfUsage = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Brugsbetingelser
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            Sidst opdateret: 27. november 2025
          </p>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                1. Om tjenesten
              </h2>
              <p>
                Mineksamen.dk er en hjemmeside hvor studerende kan øve deres
                mundtlige eksamen med en AI-eksaminator. Her bliver den
                studerende mundtligt eksamineret baseret på det der sker på den
                studerendes skærm.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                2. Indsamling og opbevaring af data
              </h2>
              <p className="mb-3">Vi indsamler og opbevarer følgende data:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Kontooplysninger:</strong> Navn, email, skole,
                  uddannelse, semester og om man er studerene eller ej.
                </li>
                <li>
                  <strong>Når man tager en eksamen gemmer vi:</strong> start
                  tidspunkt, slut tidspunkt, hvilken eksamen man har taget,
                  karakter, feedback og hvordan eksamen blev afsluttet
                </li>
                <li>
                  <strong>Eksamensdata</strong> Hvis man opretter en eksamen
                  gemmer vi det relevant data som titel, beskrivelse, type,
                  hvordan feedback skal gives etc.
                </li>
                <li>
                  <strong>Klassedata</strong> Hvis man tilmelder sig en klasse
                  gemmer vi hvilken klasse man tilhører
                </li>
              </ul>
              <p className="mt-3">
                <strong>Dataopbevaring:</strong> Alle data opbevares i en
                database kaldet Supabase. Supabase er open source og data er
                lagret på en server i Stockholm, Sverige (EU).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                3. Brug af AI-tjenester
              </h2>
              <p className="mb-3">
                For at fungere bruger mineksamen.dk to AI tjenester:
              </p>

              <ol className="list-decimal pl-6 space-y-2">
                <li>
                  <h3 className="font-semibold mb-2">Google Gemini API</h3>
                  <p>
                    Vi bruger Google Gemini API til at drive samtalen og også
                    til at se din skærm. Der bliver hvert 2. sekund sendt et
                    screenshot til Gemini Live API'et. Samtalerne og skærmdeling
                    bliver <strong>ikke brugt</strong> til at træne deres
                    modeller med. Se{" "}
                    <a
                      href="https://ai.google.dev/gemini-api/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-500"
                    >
                      Gemini API Terms of Service
                    </a>{" "}
                    for flere detaljer.
                  </p>
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                4. Deling af data
              </h2>
              <p>
                <strong>Vi sælger ikke dine personlige oplysninger.</strong>{" "}
                Data deles kun med de AI-udbydere, der er nævnt ovenfor, som en
                nødvendig del af tjenestens funktionalitet.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                5. Dine rettigheder
              </h2>
              <p>Du har ret til at:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Anmode om adgang til dine personlige data</li>
                <li>
                  Sletning af din konto og tilhørende data, sker ved at trykke
                  på "Slet min konto" nede i bunden af{" "}
                  <a
                    href="https://mineksamen.dk/profile"
                    target="_blank"
                    className="text-blue-600 hover:text-blue-500"
                    rel="noopener noreferrer"
                  >
                    https://mineksamen.dk/profile
                  </a>{" "}
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                6. Note om AI
              </h2>
              <p>
                AI-genereret indhold kan være unøjagtigt. MinEksamen.dk er et
                træningsværktøj og erstatter ikke rigtige eksamener eller
                professionel vejledning. Brug altid din egen dømmekraft, når du
                modtager karakter og feedback fra tjenesten. De kan være
                misvisende!
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                7. Ændringer af betingelser
              </h2>
              <p>
                Vi forbeholder os retten til at opdatere disse betingelser. Ved
                væsentlige ændringer vil vi informere dig via email eller ved
                login.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                8. Hvem kan jeg klage til
              </h2>
              <p className="mb-3">
                Hvis du mener, at MinEksamen's behandling af dine personoplysninger er i
                strid med gældende regler, kan du klage. Klager sendes til:{" "}
                <a
                  href="mailto:gdpr@ek.dk"
                  className="text-blue-600 hover:text-blue-500"
                >
                  gdpr@ek.dk
                </a>
                . EK vil herefter indlede en undersøgelse og sikre, at klagen
                undersøges grundigt, og at du får et svar. Dette skyldes at MinEksamen ligger inde under EK (Erhvervsakademi København)
              </p>
              <p className="mb-3">
                Du kan klage til Datatilsynet, hvis du mener, at MinEksamen ikke
                behandler dine oplysninger korrekt, eller hvis du mener, at dine
                rettigheder er blevet krænket. Du kan læse mere om dine
                klagemuligheder på Datatilsynets hjemmeside.
              </p>
              <div className="bg-gray-50 p-4 rounded-md">
                <p className="font-semibold">Datatilsynet</p>
                <p>Carl Jacobsens Vej 35</p>
                <p>2500 Valby</p>
                <p>Tlf.: 33 19 32 00</p>
                <p>
                  Mail:{" "}
                  <a
                    href="mailto:dt@datatilsynet.dk"
                    className="text-blue-600 hover:text-blue-500"
                  >
                    dt@datatilsynet.dk
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.datatilsynet.dk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-500"
                  >
                    www.datatilsynet.dk
                  </a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                9. Kontakt
              </h2>
              <p>
                Hvis du har spørgsmål til disse betingelser eller ønsker at
                udøve dine rettigheder, kan du kontakte os på{" "}
                <a href="mailto:behu@ek.dk">behu@ek.dk</a>
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link
              to="/signup"
              className="text-blue-600 hover:text-blue-500 font-medium"
            >
              ← Tilbage til oprettelse
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsOfUsage;
